import React, { Fragment } from 'react';
import Storage from 'localStorage';
import Translate from '../../utils/Translate';
import Subscription from '../../app/subscription';
import GenerateIdeas from '../../components/detail/GenerateIdeasForm';
import './content.css';
import Landing from '../../app/landing';


const token = Storage.getItem('token') || '';

const Content = ({ user, lang, country }) => {
  // If days are less than 7 to show the form
  // If days are more than 7 and suscription == null to show the trail was finish
  // If days are more than 7 and suscription == 1 to show the form
  // If days are more than 7 and suscription == 2 to show the renew message
  const showForm = ((user.days <= 7 && user.requests_number < 30) || (user.days >= 7 && user.has_subscription === 0)) || (user.days >= 7 && user.has_subscription === 1);
  const showTrialFinish = (user.days >= 7 || user.requests_number >= 30) && user.has_subscription === null;
  const showRenew = user.days >= 7 && user.has_subscription === 2;
  const isLoggedIn = user.uid;
  return (
    <Fragment>
      <div className="main-content">
        {token ? <Subscription showTrialFinish={showTrialFinish} showRenew={showRenew} user={user} country={country} /> : <Landing country={country} />}
        {showForm && isLoggedIn
        && (
          <div className="row justify-content-md-center col-12 ml-0 p-0">
            <div className="col-12 col-md-10 col-lg-8 p-0 pb-4">
              <div className="row justify-content-md-left p-3">
                <div className="col-12 col-sm-9 p-0">
                  <h2 className="text title title-sm">
                    {Translate.get('generateIdeas', 'Your Brief')}
                  </h2>
                  <span className="paragraph paragraph-sm">
                    {Translate.get('getHundredsOfIdeas', 'Fill out these fields to generate your ideas:')}
                  </span>
                </div>
              </div>
              <div className="row mb-5 p-3">
                <GenerateIdeas lang={lang} />
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default Content;



// WEBPACK FOOTER //
// ./src/content/components/content.jsx